export const usePrivate = `개인정보처리방침

1. 개인정보 수집목적 및 이용목적 
가. 서비스 제공에 관한 계약 이행 및 서비스 제공에 따른 요금정산 콘텐츠 제공, 구매 및 요금 결제, 물품배송 또는 청구지 등 발송, 금융거래 본인 인증 및 금융 서비스 

나. 회원 관리 회원제 서비스 이용에 따른 본인확인, 개인 식별, 불량회 원의 부정 이용 방지와 비인가 사용 방지, 가입 의사 확인, 연령확인, 만 14세 미만 아동 개인정보 수집 시 법정 대리인 동의여부 확인, 불만처리 등 민원처리, 고지사항 전달 

2. 수집하는 개인정보 항목 : 이름(필수), 로그인ID(필수), 휴대전화번호(필수), 이메일(필수), 주소 정보(필수) 

3. 개인정보의 보유기간 및 이용기간 원칙적으로, 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체 없이 파기합니다. 

단, 다음의 정보에 대해서는 아래의 이유로 명시한 기간 동안 보존합니다. 

가. 회사 내부 방침에 의한 정보 보유 사유 
- 부정거래 방지 및 쇼핑몰 운영방침에 따른 보관 : 1년 

나. 관련 법령에 의한 정보보유 사유 
- 계약 또는 청약철회 등에 관한 기록 
보존이유: 전자상거래 등에서의 소비자보호에 관한 법률 
보존기간: 5년 

- 대금 결제 및 재화 등의 공급에 관한 기록 
보존이유 : 전자상거래 등에서의 소비자보호에 관한 법률 
보존기간 : 5년 

- 소비자 불만 또는 분쟁처리에 관한 기록 
보존이유 : 전자상거래 등에서의 소비자보호에 관한법 률 
보존기간 : 3년 

- 로그 기록 
보존 이유 : 통신비밀보호법 
보조 기간 : 3개월 

*동의를 거부할 수 있으나 거부시 회원가입이 불가능합니다.

4.개인정보 보호의 책임자 및 담당자



가. 개인정보보호 책임자는 이용자의 개인정보를 보호하고 유출을 방지하는 책임자로서, 이용자가 안심하고 회사가 제공하는 서비스를 이용할 수 있도록 도와드립니다. 개인정보를 보호하는 데 있어 이용자에게 고지한 사항들에 반하여 사고가 발생할 시에는 이에 관한 책임을 집니다.

나. 기술적인 보완 조치를 취하였음에도 불구하고 해킹 등 기본적인 네트워크 상의 위험성에 의해 발생하는 예기치 못한 사고로 인한 정보의 훼손 및 멸실, 이용자가 작성한 게시물에 의한 각종 분쟁 등에 관해서는 책임이 없습니다.

다. 회사는 [정보통신망 이용촉진 및 정보보호 등에 관한 법률]에서 규정한 보호책임자를 다음과 같이 지정합니다.


[개인정보보호 책임자]

이름: 이헌영

전화: 0507 1336 7115

E-mail: eel051500@gmail.com 


기타 개인정보침해에 대한 신고나 상담이 필요하신 경우에는 아래 기관에 문의하시기 바랍니다.

- 개인정보침해 신고센터 (privacy.kisa.or.kr / 국번없이 118)

- 대검찰청 사이버수사과 (www.spo.go.kr / 국번없이 1301)

- 경찰청 사이버안전국 (www.ctrc.go.kr / 국번없이 182)

5.고지의 의무

현 [개인정보 취급방침]은 2024년 10월 15일에 제정되었으며, 정부 및 회사의 정책 또는 보안기술의 변경에 따라 내용의 추가, 삭제 및 수정이 있을 경우에는 개정 최소 7일 전부터 홈페이지 또는 앱 [공지사항]을 통해 고지하며, 본 정책은 시행일자에 시행됩니다.

부칙

제1 조 (시행일자) 이 개인정보 취급방침은 2024년 10월 15일부터 적용됩니다.
`;
